import jQuery from 'jquery';

export default class BetslipInteracter {
    constructor() {
        this.onUserSettingsChanged = this.onUserSettingsChanged.bind(this);
        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onCardsBookmakerChanged = this.onCardsBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
        this.decimalOdds = false;
    }

    init(feedName) {
        const customizeSettingsCookie = jQuery.cookie('customizeSettings');
        if (customizeSettingsCookie) {
            const customizeSettings = JSON.parse(customizeSettingsCookie);
            this.decimalOdds = customizeSettings.decimalOdds;
            const betslipEvent = new CustomEvent('BETSLIP.SETTINGS_CHANGED', {
                detail: { useDecimalOdds: this.decimalOdds },
            });
            document.dispatchEvent(betslipEvent);
        }
        this.bindEvents();
        if (feedName) {
            this.feedName = feedName;
            this.setBetslipBookmaker(feedName);
            return jQuery.Deferred().resolve(feedName).promise();
        }

        const deferred = jQuery.Deferred();
        this.resolvePromise = deferred.resolve;

        this.requestSelectedBookmaker();

        return deferred.promise();
    }

    onBookmakerChanged({ detail: { bookmaker } }) {
        jQuery(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
        this.resolveBookmaker(bookmaker);
    }

    resolveBookmaker(bookmaker) {
        if (this.resolvePromise) {
            this.resolvePromise(bookmaker);
            this.resolvePromise = null;
            delete this.resolvePromise;
        }
    }

    onBetslipInitialized() {
        if (this.feedName) {
            this.setBetslipBookmaker(this.feedName);
            this.resolveBookmaker(this.feedName);
        } else {
            this.requestSelectedBookmaker();
        }
    }

    requestSelectedBookmaker() {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
        document.dispatchEvent(betslipEvent);
    }

    setBetslipBookmaker(bookmaker) {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
            detail: { bookmaker },
        });
        document.dispatchEvent(betslipEvent);
    }

    onCardsBookmakerChanged(event, feedName) {
        if (!feedName) {
            return;
        }
        this.setBetslipBookmaker(feedName);
    }

    bindEvents() {
        document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
        document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
        document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        jQuery(document).on('userSettingsChanged.SETTINGS', this.onUserSettingsChanged);
        jQuery(document).on('bookieChanged.BOOKMAKER', this.onCardsBookmakerChanged);
    }

    onUserSettingsChanged(event, userSettings) {
        if (this.decimalOdds === userSettings.decimalOdds) {
            return;
        }
        this.decimalOdds = userSettings.decimalOdds;
        const betslipEvent = new CustomEvent('BETSLIP.SETTINGS_CHANGED', {
            detail: { useDecimalOdds: userSettings.decimalOdds },
        });
        document.dispatchEvent(betslipEvent);
    }

    destroy() {
        document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
        document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
        document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        jQuery(document).off('userSettingsChanged.SETTINGS', this.onUserSettingsChanged);
        jQuery(document).off('bookieChanged.BOOKMAKER', this.onCardsBookmakerChanged);
    }
}




// WEBPACK FOOTER //
// ./lib/js/modules/betslipInteracter.js